import React, {useState} from "react";
import {useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {convertToDateTime} from "components/common/dateUtils/convertToDateTime";
import {RootState, useAppDispatch} from "../../../../redux/store";

import {UtenteLogged} from "components/authentication/authenticationSlice";
import {Utenti} from "components/authentication/utenti/utentiSlice";
import {
    Ticket,
} from "../../ticketingSlice";
import CommentoAddForm from './CommentoAddForm'
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/system";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import {
    RecuperaDataCorrente,
} from "components/common/dateUtils/RecuperaDataCorrente";
import {Card, CardContent, CardHeader} from "@mui/material";

interface CommentiCardProps {
    ticket: Ticket;
    consentiModifica: boolean
}

const CommentiCard = ({
                        ticket, consentiModifica
                    }: CommentiCardProps) => {

    return (
        <Box>
            <Card raised sx={{
                m: 3, ml: 10,
                // display: "flex"
            }}
            >
                <CardHeader sx={{background: '#bfb342', color:'#eaeaeb', p: 1}} title={"Commenti e Azioni"}/>
                <CardContent sx={{width: "100%", m: 0, p: 0, backgroundColor: "#eaeaeb"}}>
                    <List sx={{mt: 0}}>
                        <ListItemText
                            key={"Lista_saldo_pallet_committente"}
                            sx={{backgroundColor: "#bfb342", color: "white", mb: 1}}
                        >
                            <Grid container spacing={{xs: 0.5, md: 1, lg: 2}} sx={{px: 2}}>
                                <Grid size={{ xs:6, sm:6, md:6, lg:8}}>
                                </Grid>
                                <Grid size={{ xs:3, sm:3, md:2, lg:2}}>
                                    <Typography variant="body2" >
                                        Autore
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs:3, sm:3, md:2, lg:2}}>
                                    <Typography variant="body2" >
                                        Data
                                    </Typography>
                                </Grid>
                            </Grid>
                        </ListItemText>
                        
                        <Box sx={{ml: 2}}>
                            <CommentoAddForm ticket={ticket} consentiModifica={consentiModifica}/>
                        </Box>

                        {ticket.commenti?.map((commento) => (
                            <Grid key={commento.id} container spacing={{xs: 0.5, md: 1, lg: 2}} sx={{px: 2}}>
                                <Grid size={{ xs:6, sm:6, md:6, lg:8}}>
                                    <Typography variant="body1" gutterBottom>
                                        {commento.testo}
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs:3, sm:3, md:2, lg:2}}>
                                    <Typography variant="body1" gutterBottom>
                                        {commento.autore_descrizione}
                                        {/*{utenti.results.find(u => u.id == commento.autore_id)?.user?.username}*/}
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs:3, sm:3, md:2, lg:2}}>
                                    <Typography variant="body1" gutterBottom display="inline">
                                        {convertToDateTime(commento.created_at)
                                            ?.setLocale("it")
                                            .toFormat("dd/MM/yyyy HH:mm")}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}


                    </List>
                </CardContent>
            </Card>


        </Box>
    );
};

export default CommentiCard;
